<template>
  <div class="popup-mask">
    <div
      class="popup-content"
      :class="{ 'pay-list': type === 'ways' }"
      v-if="!isDMM"
    >
      <div class="popup-title">
        <i
          class="popup-button"
          :class="type === 'ways' ? 'close' : 'back'"
          @click="popupOperate"
        ></i>
        <h1 class="title-text">
          {{ type === 'coupon' ? 'クーポン選択' : 'お支払い' }}
        </h1>
        <!-- <i class="popup-button question" @click="jumpToLink"></i> -->
      </div>
      <div class="select-coupon" v-if="type === 'coupon'">
        <coupon-list-popup
          :enableCouponList="coupon.enableList"
          :disableCouponList="coupon.disableList"
          :expireCouponList="coupon.expireList"
          :defaultCoupon="coupon.selectedCoupon"
          @changeSelectedCoupon="changeSelectedCoupon"
          @closeCouponSelect="popupOperate"
        ></coupon-list-popup>
      </div>
      <div class="pay-channel" v-if="type === 'ways'">
        <template>
          <div
            class="pay-ways-item"
            v-for="item in payWays"
            :key="item.type"
            @click="selectWay(item)"
          >
            <!-- <i class="way-item-icon"></i> -->
            <img
              class="way-item-icon"
              :src="`//jpabres.37games.com/h5Game/${item.type}.png`"
              alt="pay-icon"
            />
            <p class="way-item-text">
              <span class="text-span" :class="item.last ? 'last-way' : false">
                {{ item.name }}
              </span>
            </p>
            <span class="coupon-discount" v-if="item.fType === pointPayName">
              クーポン使用可能
            </span>
            <!-- 2022/4/24 区天衡：日本平台礼包商品项第三方加码功能 -->
            <span class="type-discount" v-if="item.extraRatio > 0">
              リベート {{ item.extraRatio * 100 }}%
            </span>
            <div class="way-item-select"></div>
          </div>
        </template>
      </div>
      <template v-if="type === 'info'">
        <p class="product-price">
          <span class="product-number" :class="{ 'delete-price': useCoupon }">
            {{ productInfo.TRANS_AMOUNT ? +productInfo.TRANS_AMOUNT : '' }}
          </span>
          <span class="product-number" v-if="useCoupon">
            {{ discountTransMount }}
          </span>
          &nbsp;円
        </p>
        <p class="product-name">
          + {{ productInfo.EXTRA_RATIO > 0 ? productInfo.EXTRA_COIN : 0 }}元宝
        </p>
        <div
          class="pay-ways-item"
          @click="changeWay"
          v-if="payChildList.length == 0"
        >
          <!-- <i class="way-item-icon"></i> -->
          <img
            class="way-item-icon"
            :src="`//jpabres.37games.com/h5Game/${selectedWay.type}.png`"
            alt="pay-icon"
          />
          <p class="way-item-text">
            <span
              class="text-span"
              :class="selectedWay.last ? 'last-way' : false"
            >
              {{ selectedWay.name }}
            </span>
          </p>
          <span
            class="coupon-discount"
            v-if="selectedWay.fType === pointPayName"
          >
            クーポン使用可能
          </span>
          <span class="type-discount" v-if="productInfo.EXTRA_RATIO > 0">
            リベート {{ productInfo.EXTRA_RATIO * 100 }}%
          </span>
          <div class="way-item-select"></div>
        </div>
        <div class="select-box" v-if="payChildList.length > 0">
          <div
            class="pay-ways-item"
            :class="{ 'select-channel': !childChannel.type }"
            @click="toggleChildChannelList(true)"
          >
            <img
              class="way-item-icon"
              :src="`//jpabres.37games.com/h5Game/${childChannel.type}.png`"
              alt="pay-icon"
              v-if="childChannel.type"
            />
            <p class="way-item-text">
              <span
                class="text-span"
                :class="{ 'last-way': childChannel.last }"
              >
                {{ childChannel.name }}
              </span>
            </p>
            <div class="way-item-select"></div>
          </div>
        </div>
        <!-- 不用v-if而用样式控制，是因为出现的时候会闪一下 -->
        <div class="coupon" :class="{ 'show-coupon': showCoupon }">
          <span class="coupon-label">クーポン選択：</span>
          <div class="coupon-select">
            <span class="coupon-select-target" v-if="!coupon.selectedCoupon">
              未選択のクーポン
            </span>
            <span v-else-if="activePaytypeCouponFullReductType">
              {{ activePaytypeCouponReductionName }}
            </span>
            <span v-else>
              {{ activePaytypeCouponDiscountName }}
            </span>
            <a
              class="coupon-select-change"
              href="javascript:;"
              @click="goToSelectCoupon"
            >
              クーポン選択 >>
            </a>
          </div>
        </div>
        <div class="child-channel-select" v-show="isShowChildChannelList">
          <div class="box">
            <div
              v-for="item in payChildList"
              :key="item.type"
              class="pay-ways-item"
              @click="updateChildChannel(item)"
            >
              <img
                class="way-item-icon"
                :src="`//jpabres.37games.com/h5Game/${item.type}.png`"
                alt="pay-icon"
                v-if="item.type"
              />
              <p class="way-item-text">
                <span class="text-span" :class="{ 'last-way': item.last }">
                  {{ item.name }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div
          class="points-pay-info"
          v-if="
            selectedWay.fType === pointPayName &&
              selectedWay.type === pointPayName
          "
        >
          <div class="points-pay-info-top">
            <p class="text">
              交換コイン 残り:
              <span class="text-balance">{{ pointBalance }}</span>
              {{ selectedWay.currency }}
            </p>
            <a
              href="javascript:;"
              class="refresh"
              :class="{ ani: boolPlayRefreshAni }"
              @click="refreshBalance"
            ></a>
          </div>
          <div class="points-pay-info-bottom">
            <p class="enough" v-if="afterPayPointBalance >= 0">
              支払った後の残高: {{ afterPayPointBalance }}
              {{ selectedWay.currency }}
            </p>
            <p class="not-enough" v-else>
              残高が足りません。チャージしてください。
            </p>
          </div>
        </div>
        <div class="form-box" :class="{ margin: payChildList.length == 0 }">
          <Formbox
            v-show="isForm"
            :type="item.type"
            v-for="(item, key) in childForm"
            :key="key"
          >
            <Input
              :defaultValue="''"
              :attr="key"
              :tips="item.tips"
              :title="item.title"
              :slot="'text'"
              :msg="item.msg"
              v-on:updateValue="updateFormValue"
            />
          </Formbox>
        </div>
        <div class="bottom-content" :class="{ 'form-btn': isForm }">
          <div class="confirm-content" v-if="!hasSelect">
            <p class="confirm-tips">
              20歳未満は購入できません。20歳以上ですか？
            </p>
            <label class="confirm-label right">
              <input
                class="hidden-input"
                type="radio"
                name="over20"
                value="はい"
                checked
              />
              <i class="bui-radios"></i>
              はい
            </label>
            <label class="confirm-label left">
              <input
                class="hidden-input"
                type="radio"
                name="over20"
                value="いいえ"
              />
              <i class="bui-radios"></i>
              いいえ
            </label>
          </div>
          <div
            v-if="showPointsPayBtn"
            class="confirm-button"
            @click="goToPointPay"
          >
            チャージへ
          </div>
          <div
            v-else
            class="confirm-button"
            :class="canClick ? false : 'disabled'"
            @click="confirmPay"
          >
            <i class="loading" v-show="isload"></i>
            お支払い
          </div>
        </div>
      </template>
    </div>
    <div id="dmm-content" class="popup-content" v-if="isDMM">
      <div class="popup-title">
        <h1 class="title-text">購入確認</h1>
        <i class="popup-button close" @click="showCloseConfirm = true"></i>
        <!-- <i class="popup-button question" @click="jumpToLink"></i> -->
      </div>
      <ul class="content" v-show="!isDMMFailTips">
        <li class="item game-name">
          <span>旦那様の一発逆転人生</span>
        </li>
        <li class="item goods-name">
          <span>
            {{ productInfo.PRODUCT_NAME || productInfo.PRODUCT_DESC }}
          </span>
        </li>
        <li class="item price">
          <span class="tip">単価</span>
          <span class="number">{{ productInfo.TRANS_AMOUNT }}</span>
        </li>
        <li class="item count">
          <span class="tip">個數</span>
          <span class="number">1</span>
        </li>
        <li class="item total-price">
          <span class="tip">合計ポイント</span>
          <span class="number">{{ productInfo.TRANS_AMOUNT }}</span>
        </li>
        <li class="item remain-price">
          <span class="tip">所持ポイント</span>
          <span class="number">{{ productInfo.CAN_USE_POINT }}</span>
        </li>
        <li class="item to-pay" @click="confirmPayDMM">
          <span>続ける</span>
        </li>
        <li class="item return-game" @click="showCloseConfirm = true">
          <span>ゲームに戻る</span>
        </li>
      </ul>
      <ul class="content content-error" v-show="isDMMFailTips">
        <li class="item game-name">
          <span>旦那様の一発逆転人生</span>
        </li>
        <li class="item fail-tips">
          <span class="err-msg">{{ faileTipsText }}</span>
        </li>
        <li class="item repay" @click="toStore">
          <span class="tip">ポイントをチャージする</span>
        </li>
        <li class="item return-game" @click="showCloseConfirm = true">
          <span>ゲームに戻る</span>
        </li>
      </ul>
    </div>
    <div v-if="showCloseConfirm" class="popup-mask question">
      <div class="popup-content">
        <p class="close-tips">お支払をキャンセルしますか？</p>
        <div class="button-group">
          <div class="button-item" @click="closePopup">YES</div>
          <div class="button-item reject" @click="cancelClose">NO</div>
        </div>
      </div>
    </div>
    <div v-show="submitTips" class="popup-mask question">
      <div class="popup-content">
        <p class="close-tips">{{ submitTips }}</p>
        <div class="button-group">
          <div class="button-item" @click="closeSubmitTips">YES</div>
        </div>
      </div>
    </div>
    <div v-show="pointsPayConfirm" class="popup-mask balance">
      <div class="popup-content">
        <p class="text">
          交換コイン 残り:
          <span class="text-balance">{{ pointBalance }}</span>
          {{ selectedWay.currency }}
        </p>
        <p>残高が足りません。チャージしてください。</p>
        <div class="button-group">
          <a href="javascript:;" class="choose-other" @click="chooseOtherPay">
            他の支払い方法
          </a>
          <a href="javascript:;" class="to-pay" @click="chooseGotoPayPoint">
            チャージへ
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmptyObj } from '../store/ultile';
import {
  SUBMIT_PAY_TYPE,
  DATAIN_DATA,
  HREF_IS_DMM,
  GET_CHILD_LIST,
  GET_CHILD_FORM,
  RESET_CHILD_LIST,
  RESET_CHILD_FORM,
  UPDATE_BOOL_SEND_VIP_COUPON,
  GET_POINT_BALANCE,
  GET_PAY_COUPON_LIST,
  GET_SEND_VIP_COUPON
} from '../store/web/h5';
import Input from './editor/Input';
import Listener from '../mixins/listener';
import globalConfig from '../utiles/globalConfig';
import CouponListPopup from './CouponListPopup.vue';
import Formbox from './FormBox';
import { times, minus } from '../utiles/index';

const SUCCESS_RESULT_CODE = 1;
const DMM_STORE_FAILE_CODE = '0';

const presetChildChannel = {
  type: '',
  name: 'チャージ方法の選択',
  last: false
};

export default {
  name: 'storePopup',
  data() {
    return {
      type: 'ways',
      showCloseConfirm: false,
      selectedWay: {},
      hasSelect: true,
      canClick: true,
      isload: true,
      isDMMFailTips: false,
      faileTipsText: '',
      isDMM: HREF_IS_DMM,
      isShowChildChannelList: false,
      childChannel: presetChildChannel,
      needForm: false,
      formData: {},
      submitTips: '',
      pointBalance: 0,
      pointRefreshThrottle: {
        timer: null,
        canRefreshPoint: true
      },
      boolPlayRefreshAni: false,
      pointsPayConfirm: false,
      pointPayName: 'points_pay',
      coupon: {
        selectedCoupon: null,
        enableList: [],
        disableList: [],
        expireList: []
      },
      amazonCheckoutSessionId: '' // 2025-04-07 gmo升级v2需求 保存amazon pay的sessionid
    };
  },
  props: {
    sdkParam: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    'childChannel.type'(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.$store.dispatch(RESET_CHILD_FORM);
        this.resetFormValue();
        this.$store
          .dispatch(GET_CHILD_FORM, {
            fType: this.selectedWay.fType,
            pay_type: this.selectedWay.type,
            child_id: newValue
          })
          .then((res) => {
            this.canClick = true;
            this.isload = true;
          });
      }
    },
    selectedWay(newValue, oldValue) {
      this.$store.dispatch(RESET_CHILD_LIST);
      this.$store.dispatch(RESET_CHILD_FORM);
      this.childChannel = presetChildChannel;
      if (newValue.fType === 'gmo') {
        this.$store
          .dispatch(GET_CHILD_LIST, {
            fType: newValue.fType,
            pay_type: newValue.type
          })
          .then((res) => {
            if (res.length == 0) {
              this.$store.dispatch(GET_CHILD_FORM, {
                fType: this.selectedWay.fType,
                pay_type: this.selectedWay.type,
                child_id: ''
              });
            }
          });
      }
      // 2025-04-07 gmo升级v2需求 渠道变更，需要重置gmo的amazonpay的sessionid
      if (
        newValue.fType !== oldValue.fType ||
        newValue.type !== oldValue.type
      ) {
        this.amazonCheckoutSessionId = '';
      }
    },
    // 2025-04-07 gmo升级v2需求 监听gmo的amazon pay渠道的支付窗口的回调sessionid
    isGMOAmazonPayLoginBtn(newVal) {
      if (newVal) {
        window.addEventListener(
          'message',
          this.updateGMOAmazonPaySessionMessage
        );
      } else {
        window.removeEventListener(
          'message',
          this.updateGMOAmazonPaySessionMessage
        );
      }
    }
  },
  mixins: [Listener],
  components: {
    Input,
    Formbox,
    CouponListPopup
  },
  computed: {
    ...mapGetters({
      payWays: 'storeWay',
      gameId: 'gameId',
      tmpProductInfo: 'productInfo',
      dmmProductInfo: 'dmmProductInfo',
      accountId: 'accountId',
      lang: 'lang',
      serverList: 'serverList',
      childForm: 'childForm',
      boolSendVipCoupon: 'boolSendVipCoupon'
    }),
    // 展示优惠金额
    useCoupon() {
      return (
        this.selectedWay.fType === this.pointPayName &&
        !!this.coupon.selectedCoupon
      );
    },
    // 使用优惠卷后的金额
    discountTransMount() {
      const curPrice = +this.productInfo.TRANS_AMOUNT;
      if (!this.coupon.selectedCoupon) {
        return curPrice;
      }
      let newPrice = minus(curPrice, this.activePaytypeCouponReductPrice);
      if (newPrice <= 0) {
        newPrice = 0;
      }
      return newPrice.toFixed(2);
    },
    // 优惠卷：满减
    activePaytypeCouponFullReductType() {
      return +this.coupon.selectedCoupon.TYPE === 0;
    },
    // 使用：优惠卷减去的金额
    activePaytypeCouponReductPrice() {
      return +this.coupon.selectedCoupon.REDUCTION_MONEY || 0;
    },
    // 优惠卷：满减金额
    activePaytypeCouponReductionName() {
      return (
        '- ' +
        this.coupon.selectedCoupon.REDUCTION_MONEY +
        ' ' +
        this.coupon.selectedCoupon.CURRENCY
      );
    },
    // 优惠卷：折扣
    activePaytypeCouponDiscountName() {
      return times(this.coupon.selectedCoupon.DISCOUNT, 100) + '%OFF';
    },
    submitCouponInfoName() {
      if (!this.coupon.selectedCoupon) {
        return '';
      }
      if (this.activePaytypeCouponFullReductType) {
        return this.activePaytypeCouponReductionName;
      }
      return this.activePaytypeCouponDiscountName;
    },
    showCoupon() {
      return (
        this.selectedWay.fType === this.pointPayName && this.showCouponSelect
      );
    },
    showCouponSelect() {
      return (
        this.coupon.enableList.length > 0 ||
        this.coupon.disableList.length > 0 ||
        this.coupon.expireList.length > 0
      );
    },
    showPointsPayBtn() {
      if (this.useCoupon) {
        return (
          this.selectedWay.fType === this.pointPayName &&
          this.selectedWay.type === this.pointPayName &&
          +this.discountTransMount > +this.pointBalance
        );
      }
      return (
        this.selectedWay.fType === this.pointPayName &&
        this.selectedWay.type === this.pointPayName &&
        +this.afterPayPointBalance < 0
      );
    },
    afterPayPointBalance() {
      if (this.useCoupon) {
        return minus(this.pointBalance, this.discountTransMount);
      }
      return minus(this.pointBalance, this.sdkParam.price);
    },
    isForm() {
      return Object.keys(this.childForm).length > 0;
    },
    payChildList() {
      if (this.$store.getters.payChildList.length > 0) {
        this.canClick = false;
        this.isload = false;
      } else {
        this.canClick = true;
        this.isload = true;
      }
      return this.$store.getters.payChildList;
    },
    productInfo() {
      if (this.isDMM) {
        return this.dmmProductInfo;
      } else {
        let data = this.tmpProductInfo.find(
          (item) => item.type === this.selectedWay.type
        );
        return data ? data.commodity : {};
      }
    },
    // 2025-04-07 gmo升级v2需求 是否需要先获取gmo的amazon pay渠道的支付窗口sessionid
    isGMOAmazonPayLoginBtn() {
      return this.isGMOAmazonPay && !this.amazonCheckoutSessionId;
    },
    // 2025-04-07 gmo升级v2需求 是否是gmo的amazon pay渠道
    isGMOAmazonPay() {
      return (
        this.selectedWay.fType === 'gmo' &&
        this.selectedWay.type === 'amazon_pay'
      );
    }
  },
  methods: {
    chooseOtherPay() {
      this.pointsPayConfirm = false;
      this.popupOperate();
    },
    chooseGotoPayPoint() {
      this.pointsPayConfirm = false;
      this.goToPointPay();
    },
    goToPointPay() {
      let url =
        '//jpstore.37games.com/mobile/signin?gameId=2&scid=h5&cid=h5#/coins';
      window.open(window.globalGetGotoLink({ link: url }), '_blank');
    },
    toStore() {
      this.collectData({ event: 'click', ext1: '余额不足，点击去dmm储值' });
      window.open('https://point.dmm.com/choice/pay');
    },
    collectData(data) {
      this.$store.dispatch(DATAIN_DATA, {
        loginAccount: HREF_IS_DMM
          ? localStorage.getItem('currLoginAccount')
          : this.accountId,
        ...data
      });
    },
    goToSelectCoupon() {
      const typeValue = 'coupon';
      this.type = typeValue;
      this.collectData({
        event: 'click',
        ext1: '进入选择优惠卷弹窗'
      });
    },
    selectWay(item) {
      this.selectedWay = item;
      this.type = 'info';
      this.collectData({
        event: 'click',
        ext1: '选择储值渠道',
        ext2: item.type
      });
      if (item.fType === this.pointPayName && item.type === this.pointPayName) {
        this.getPointBalance();
        this.getCouponList();
      }
    },
    changeWay() {
      this.type = 'ways';
      this.collectData({ event: 'click', ext1: '切换储值渠道' });
    },
    playRefreshAni() {
      this.boolPlayRefreshAni = true;
    },
    stopRefreshAni() {
      this.boolPlayRefreshAni = false;
    },
    async refreshBalance() {
      // 1.5秒后才给再次刷新一次
      if (!this.pointRefreshThrottle.canRefreshPoint) {
        return;
      }
      this.playRefreshAni();
      this.pointRefreshThrottle.canRefreshPoint = false;
      clearTimeout(this.pointRefreshThrottle.timer);
      await this.getPointBalance();
      this.pointRefreshThrottle.timer = setTimeout(() => {
        this.stopRefreshAni();
        this.pointRefreshThrottle.canRefreshPoint = true;
      }, 1000);
    },
    async justifyIsEnoughPointToPay() {
      await this.getPointBalance();
      return Promise.resolve(this.afterPayPointBalance >= 0);
    },
    getPointBalance() {
      const successCallback = (data) => {
        if (data && /Array/i.test(data.balanceList.constructor.toString())) {
          const balanceListItem = data.balanceList.find(
            (item) => item.currency === 'JPY'
          );
          if (balanceListItem) {
            this.pointBalance = balanceListItem.amount;
          }
          return;
        }
        this.pointBalance = 0;
      };
      const failCallback = (msg) => {
        this.type = 'ways';
        alert(msg);
      };
      return this.$store
        .dispatch(GET_POINT_BALANCE)
        .then(({ res }) => {
          +res.result === 1 ? successCallback(res.data) : failCallback(res.msg);
        })
        .catch((err) => {
          failCallback(err);
        });
    },
    changeSelectedCoupon(selectedCoupon) {
      this.coupon.selectedCoupon = selectedCoupon;
    },
    // vip系统：发放优惠券
    getSendCoupon() {
      if (this.boolSendVipCoupon) {
        return Promise.resolve();
      }
      return this.$store
        .dispatch(GET_SEND_VIP_COUPON, { game_id: parseInt(this.gameId, 10) })
        .then(() => {
          this.$store.commit(UPDATE_BOOL_SEND_VIP_COUPON, true);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 查看优惠券列表
    getCouponList() {
      const successCallback = (data) => {
        if (data) {
          this.coupon.enableList = data.enable || [];
          this.coupon.disableList = data.disable || [];
          this.coupon.expireList = data.expire || [];
        }
      };
      const failCallback = (msg) => {
        this.coupon.enableList = [];
        this.coupon.disableList = [];
        this.coupon.expireList = [];
        alert(msg);
      };
      const params = {
        game_id: parseInt(this.gameId, 10),
        f_pay_type: this.selectedWay.fType,
        pay_type: this.selectedWay.type,
        currency: this.selectedWay.currency,
        amount: this.productInfo.TRANS_AMOUNT,
        product_type: '', // 不用传
        product_id: this.sdkParam.productId,
        cp_product_id: this.sdkParam.remark
      };
      this.$store
        .dispatch(GET_PAY_COUPON_LIST, params)
        .then(({ res }) => {
          +res.result === 1 ? successCallback(res.data) : failCallback(res.msg);
        })
        .catch((err) => {
          failCallback(err);
        });
    },
    popupOperate() {
      if (this.type === 'info') {
        this.type = 'ways';
        this.isShowChildChannelList = false;
        this.collectData({ event: 'click', ext1: '返回选择渠道页面' });
      } else if (this.type === 'coupon') {
        this.type = 'info';
        this.collectData({ event: 'click', ext1: '从优惠券返回渠道详情' });
      } else {
        this.showCloseConfirm = true;
        this.collectData({ event: 'click', ext1: '关闭储值渠道页面' });
      }
    },
    jumpToLink() {
      window.open('https://www.google.com');
    },
    cancelClose() {
      this.showCloseConfirm = false;
      this.collectData({ event: 'click', ext1: '取消关闭储值渠道页面' });
    },
    closePopup(isClick = true) {
      this.$emit('close');
      if (isClick) {
        this.collectData({ event: 'click', ext1: '确认关闭储值渠道页面' });
      }
    },
    async confirmPay() {
      if (this.canClick) {
        if (isEmptyObj(this.productInfo)) {
          this.submitTips =
            '製品情報はまだ取得されていません。更新してください';
          return;
        }
        if (this.isGMOAmazonPayLoginBtn) {
          // 外跳打开gmo的amazon pay的登录页面
          window.open(`https://jpstore.37games.com/amazon-pay.html`, '_blank');
          return;
        }

        let realFormData = {};
        if (this.isForm) {
          let res = true;
          let name = '';
          for (let key in this.childForm) {
            // 如果是没填的话，就不传给后端了，传了的话就rsa编码一下(又不编码了)
            if (this.formData[key]) {
              realFormData[key] = this.formData[key];
            }
            if (!this.formData[key] && this.childForm[key].must === '1') {
              name = this.childForm[key].title;
              res = false;
              break;
            }
          }
          if (!res) {
            this.submitTips = `${name} が指定されていません`;
            return;
          }
        }
        const serverId =
          (
            this.serverList.find(
              (item) => +item.SID === +this.sdkParam.serverId
            ) || {}
          ).ID || '';
        if (!serverId) {
          this.submitTips = 'サーバーリストはまだありません。更新してください';
          return;
        }
        try {
          globalConfig.statistics('submit_pay', {
            pid: this.sdkParam.productId,
            pay_type: this.selectedWay.type
          });
        } catch (e) {}
        this.canClick = false;
        const mainHost = '//jpstore.37games.com/';
        let url = mainHost + this.selectedWay.fType + '/submit';
        let isClosePayPopup = true;
        let failAgainUrl =
          '/mobile/paytype?' +
          [
            'is_login=1',
            'gameId=' + parseInt(this.gameId, 10),
            'serverId=' + parseInt(serverId, 10) || 0,
            'roleId=' + this.sdkParam.roleId || 0,
            'userId=' + this.accountId || '',
            'productId=' + this.sdkParam.productId,
            'payType=' + this.selectedWay.type,
            'productDesc=' + this.productInfo.PRODUCT_NAME || '',
            'packageName=' + this.packageName || '',
            'payAgain=1'
          ].join('&');
        let commonParams =
          window.globalGetLinkParams && window.globalGetLinkParams();
        if (commonParams) {
          Object.keys(commonParams).forEach((key) => {
            failAgainUrl += `&${key}=${commonParams[key]}`;
          });
        }
        let params = {
          gameId: parseInt(this.gameId, 10),
          serverId: parseInt(serverId, 10) || 0,
          roleName: encodeURIComponent(this.sdkParam.roleName),
          roleId: this.sdkParam.roleId,
          paytype: this.selectedWay.type,
          productId: this.sdkParam.productId,
          remark: this.sdkParam.remark || this.sdkParam.price || '',
          cpProductId: this.sdkParam.cpProductId,
          amount: this.productInfo.TRANS_AMOUNT,
          amountDesc: this.productInfo.TRANS_AMOUNT,
          currency: this.selectedWay.currency,
          devicePlate: window.isPhone ? 'wap' : 'pc',
          is_sdk_view: '',
          language: 'jp',
          location: 'JP',
          productDesc:
            (this.productInfo.PRODUCT_NAME || '').replace(/.*(?:\=)/, '') +
            ' + ' +
            (this.productInfo.EXTRA_RATIO > 0
              ? this.productInfo.EXTRA_COIN
              : 0) +
            '元宝',
          failAgainUrl: failAgainUrl,
          isJMH5: 1,
          uid: this.$store.state.accountId,
          userId: this.$store.state.accountId,
          cid: 'h5',
          scid: globalConfig.getHrefParam('scid'),
          packageName: globalConfig.packageName,
          redirectPath: '/platform/officialTopup.html',
          curReferer: 'pay.37games.com',
          ...window.globalGetLinkParams(),
        };
        if (this.isForm) {
          params = {
            ...params,
            ...realFormData,
            child_id: this.childChannel.type
          };
        }
        // 如果是gmo的amazon pay渠道，还要补上
        if (this.isGMOAmazonPay) {
          params['amazonCheckoutSessionId'] = this.amazonCheckoutSessionId;
        }
        if (this.selectedWay.fType === this.pointPayName) {
          Object.assign(params, {
            flowType: '-1'
          });
          if (this.coupon.selectedCoupon) {
            Object.assign(params, {
              couponId: this.coupon.selectedCoupon.COUPON_ID || '',
              couponInfoName: this.submitCouponInfoName,
              discountAfterAmount: this.coupon.selectedCoupon.COUPON_ID
                ? `${this.discountTransMount} ${this.selectedWay.currency}`
                : ''
            });
          }
          // 代币支付前判断余额是否足够
          const boolEnoughPointToPay = await this.justifyIsEnoughPointToPay();
          if (!boolEnoughPointToPay) {
            this.pointsPayConfirm = true;
            this.canClick = true;
            return;
          }
        }
        this.collectData({ event: 'click', ext1: '确认储值信息，并提单' });
        const myWin = window.open(
          `${window.location.origin}/loading.html`,
          '_blank'
        );
        this.$store
          .dispatch(SUBMIT_PAY_TYPE, { url, params })
          .then((response) => {
            var res = response.data;
            if (SUCCESS_RESULT_CODE != res.result) {
              var errmsg =
                (res && res.msg && res.msg.replace(/\[\-\d*\]/, '')) || '';
              this.canClick = true;
              myWin.close();
              setTimeout(() => {
                alert(errmsg);
              }, 100);
            } else {
              let { result, data, msg } = res;
              if (result === '1') {
                const type = parseInt(data.type, 10);
                if (type === 1 || type === 11) {
                  myWin.location.href = data.redirect_url;
                } else if (type === 2) {
                  let origin =
                    process.env.NODE_ENV === 'production'
                      ? window.location.origin
                      : 'http://higawari.37games.com';
                  myWin.postMessage(data, origin);
                } else if (type === 6) {
                  if (data.errors) {
                    myWin.close();
                    isClosePayPopup = false;
                    this.submitTips = data.errors[0];
                  } else {
                    let _url = `https://jpstore.37games.com/html/h5GMOPayResult.html?result=1&gameId=${
                      this.gameId
                    }&serverId=${serverId}&roleId=${
                      this.sdkParam.roleId
                    }&roleName=${encodeURIComponent(
                      this.sdkParam.roleName
                    )}&userName=${this.accountId}&type=${
                      this.selectedWay.type
                    }&msg=${encodeURIComponent(JSON.stringify(data.show))}`;
                    myWin.location.href = window.globalGetGotoLink({
                      link: _url
                    });
                  }
                }
              } else {
                let args = '';
                let url =
                  '//jpstore.37games.com/display_pay_result?language=jp&result=' +
                  result +
                  '&msg=' +
                  msg;
                for (let i in data) {
                  args += '&';
                  args += i;
                  args += '=';
                  args += data[i];
                }
                url += args;
                myWin.location.href = window.globalGetGotoLink({ link: url });
              }
              this.canClick = true;
              // if (!this.hasSelect) {
              //   window.localStorage.setItem("JSMR_SET_AGE", "1");
              // }
              if (isClosePayPopup) {
                this.closePopup(false);
              }
            }
            // 2025-04-07 gmo升级v2需求 储值完后，重置gmo的amazon pay的sessionid
            this.amazonCheckoutSessionId = '';
          })
          .catch(() => {});
      }
    },
    confirmPayDMM() {
      if (isEmptyObj(this.productInfo)) {
        alert('製品情報はまだ取得されていません。更新してください');
        return;
      }
      try {
        globalConfig.statistics('submit_pay', {
          pid: this.sdkParam.productId,
          pay_type: 'dmm'
        });
      } catch (e) {}
      this.canClick = false;
      const mainHost = '//jpstore.37games.com/';
      let url = mainHost + 'dmm/submit';
      let params = {
        gameId: parseInt(this.gameId, 10),
        serverId: this.sdkParam.serverId,
        roleName: encodeURIComponent(this.sdkParam.roleName),
        roleId: this.sdkParam.roleId,
        paytype: 'dmm',
        productId: this.sdkParam.productId,
        amount: this.productInfo.TRANS_AMOUNT,
        remark: this.sdkParam.remark || this.sdkParam.price || '',
        currency: this.productInfo.CURRENCY,
        devicePlate: window.isPhone ? 'wap' : 'pc',
        is_sdk_view: '',
        language: 'jp',
        location: 'JP',
        productDesc: (this.productInfo.PRODUCT_NAME || '').replace(
          /.*(?:\=)/,
          ''
        ),
        isJMH5: 1,
        ...window.globalGetLinkParams()
      };
      this.collectData({ event: 'click', ext1: '确认储值信息，并提单' });
      this.$store
        .dispatch(SUBMIT_PAY_TYPE, { url, params })
        .then((response) => {
          const res = response.data;
          if (DMM_STORE_FAILE_CODE === res.result) {
            this.collectData({
              event: 'open',
              ext1: '储值失败，展示失败页面'
            });
            this.isDMMFailTips = true;
            this.faileTipsText = res.msg;
          } else {
            this.closePopup();
          }
        })
        .catch(() => {});
    },
    toggleChildChannelList(target) {
      this.isShowChildChannelList = !!target;
      if (target) {
        this.collectData({
          event: 'click',
          ext1: '选择子储值渠道'
        });
      }
    },
    updateChildChannel(item) {
      this.toggleChildChannelList(false);
      this.childChannel = item;
    },
    updateFormValue(data) {
      this.formData[data.attr] = data.value;
    },
    resetFormValue() {
      this.formData = {};
    },
    closeSubmitTips() {
      this.submitTips = '';
    },
    // 2025-04-07 gmo升级v2需求 监听gmo的amazon pay渠道的支付窗口的回调sessionid  ，并赋值
    updateGMOAmazonPaySessionMessage(event) {
      let data = event.data || {};
      if (
        data.action == 'gmo-amazon-pay-callback' &&
        data.amazonCheckoutSessionId
      ) {
        this.amazonCheckoutSessionId = data.amazonCheckoutSessionId;
      }
    }
  },
  async created() {
    // this.hasSelect = window.localStorage.getItem("JSMR_SET_AGE");
    let lastWay = this.payWays.find((item) => item.last);
    if (lastWay) {
      this.selectedWay = lastWay;
      this.type = 'info';
    }
    // 1、打开渠道弹窗，先发优惠券
    await this.getSendCoupon();
    // 上次一次储值是代币时，会直接展示代币弹窗，需要自动加载代币余额和优惠卷
    if (lastWay && lastWay.fType === this.pointPayName) {
      this.getPointBalance();
      // 2、再获取优惠券列表
      this.getCouponList(this.sdkParam && this.sdkParam.productId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/base.scss';
$img: '../assets/image/';
@mixin scrollbar {
  &::-webkit-scrollbar {
    width: 6vh;
    background-color: white;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 100px;
  }
}
@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.popup-mask {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  position: fixed;
  background: rgba($color: #000000, $alpha: 0.8);
  &.question {
    z-index: 100;
  }
  .tips-content {
    top: 50%;
    left: 50%;
    width: 525vh;
    height: auto;
    color: #fff;
    padding: 30vh;
    position: absolute;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
  }
  .popup-content {
    top: 50%;
    left: 50%;
    height: auto;
    padding: 30vh;
    width: 625vh;
    max-width: 100%;
    background: #fff;
    border-radius: 10vh;
    position: absolute;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    transition-duration: 0.3s;
    .close-tips {
      font-size: 22vh;
      margin-top: 65vh;
      font-weight: 700;
      text-align: center;
      margin-bottom: 45vh;
    }
    .button-group {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .button-item {
        width: 178vh;
        height: 48vh;
        color: #fff;
        cursor: pointer;
        line-height: 48vh;
        text-align: center;
        border-radius: 24vh;
        background-color: #d670e1;
        &.reject {
          background-color: #9a9a9a;
        }
      }
    }
    .coupon-discount,
    .type-discount {
      display: inline-block;
      padding: 0 8vh;
      border: 1px solid #de2626;
      color: #de2626;
      text-align: center;
      line-height: 20vh;
      font-size: 12vh;
      margin-right: 12vh;
    }
  }
  .pay-list {
    padding-right: 20vh;
  }
  .pay-channel {
    height: 586vh;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    padding-right: 10vh;
    @include scrollbar;
  }
  .coupon {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 22px;
    height: 0;
    transition-duration: 0.3s;
    &.show-coupon {
      height: 80vh;
    }
    &-label {
      font-weight: bold;
    }
    &-select {
      box-sizing: border-box;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20vh;
      height: 80vh;
      border: 1px solid #b9b7b3;
      border-radius: 10px;
      font-size: 16vh;
      &-change {
        color: #d670e1;
      }
    }
  }
  .popup-title {
    position: relative;
    margin-bottom: 20vh;

    .popup-button {
      width: 23vh;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      background-size: 23vh 23vh;
      &.back {
        background-image: url($img+'back.png');
      }
      &.close {
        background-image: url($img+'close.png');
      }
      &.question {
        background-image: url($img+'question.png');
      }
    }
    .title-text {
      flex: 1;
      margin: 0;
      font-size: 22vh;
      font-weight: 700;
      text-align: center;
    }
  }
  .pay-ways-item {
    height: 80vh;
    display: flex;
    cursor: pointer;
    border-radius: 10px;
    margin-bottom: 10vh;
    align-items: center;
    padding-right: 20vh;
    box-sizing: border-box;
    border: 1px solid #b9b7b3;
    justify-content: space-between;
    .way-item-icon {
      flex: 0 0 104vh;
      width: 104vh;
      height: 47vh;
    }
    .way-item-text {
      flex: 1;
      color: #000;
      font-size: 14vh;
      font-weight: 700;
      .text-span {
        position: relative;
        &.last-way:after {
          top: -3vh;
          left: 110%;
          width: 66vh;
          padding: 4vh;
          height: 16vh;
          color: #fff;
          font-size: 12vh;
          line-height: 18vh;
          content: '前回使用';
          border-radius: 3px;
          position: absolute;
          background: #58e078;
        }
      }
    }
    .way-item-select {
      width: 22vh;
      height: 20vh;
      flex: 0 0 22vh;
      background-size: 100% 100%;
      background-image: url($img+'select.png');
    }
  }
  .select-box {
    position: relative;
    .select-channel {
      .way-item-text {
        .text-span {
          color: #bcbcbc;
          font-weight: 100;
          padding-left: 30vh;
        }
      }
    }
    .way-item-select {
      background-size: 100% 100%;
      background-image: url($img+'select1.png');
    }
  }
  .child-channel-select {
    position: absolute;
    width: 100%;
    height: 100%;
    // background: rgba(255, 255, 255, 0.8);
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    border-radius: 10vh;
    .box {
      position: absolute;
      background-color: white;
      width: calc(100% - 30vh);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border: 1px solid #b9b7b3;
      border-radius: 10px;
      box-sizing: border-box;
    }
    .pay-ways-item {
      border: none;
      border-bottom: 1px solid #b9b7b3;
      margin-bottom: 0;
      padding: 0;
      margin: auto 20vh;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      &:last-child {
        border: none;
      }
    }
  }

  .product-price {
    margin-top: 0;
    font-size: 24vh;
    color: #d670e1;
    text-align: center;
    // margin-bottom: 5vh;
    .product-number {
      font-size: 36vh;
      &.delete-price {
        display: inline-block;
        color: #000000;
        text-decoration: line-through;
        text-decoration-color: red;
        white-space: pre-line;
      }
    }
  }
  .product-name {
    // margin-top: 10vh;
    font-size: 18vh;
    color: #d670e1;
    text-align: center;
    margin-bottom: 30vh;
  }
  .points-pay-info {
    margin-top: 22px;
    &-top {
      margin-bottom: 8px;
      .text {
        display: inline-block;
        font-size: 18px;
        font-weight: bold;
        vertical-align: middle;
        &-balance {
          font-size: 24px;
          color: #d670e1;
        }
      }
      .refresh {
        display: inline-block;
        width: 24px * 0.8;
        height: 25px * 0.8;
        margin-left: 22px;
        background: url($img+'refresh.png') no-repeat center/contain;
        vertical-align: middle;
        filter: brightness(0);
        &.ani {
          animation: rotate 1s infinite linear;
        }
      }
    }
    &-bottom {
      font-size: 14px;
      color: #d670e1;
    }
  }
  .balance {
    .popup-content {
      overflow: hidden;
      height: 240px;
    }
    .text {
      display: inline-block;
      margin-top: 30px;
      font-size: 18px;
      font-weight: bold;
      vertical-align: middle;
      &-balance {
        font-size: 24px;
        color: #d670e1;
      }
    }
    .button-group {
      margin-top: 60px;
      .choose-other {
        width: 160px;
        height: 30px;
        border: 1px solid #d670e1;
        line-height: 30px;
        text-align: center;
        color: #d670e1;
        border-radius: 15px;
      }
      .to-pay {
        width: 160px;
        height: 30px;
        border: 1px solid #d670e1;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
        border-radius: 15px;
        background-color: #d670e1;
      }
    }
  }
  .bottom-content {
    margin-top: 114vh;
    .confirm-content {
      .confirm-tips {
        margin: 0;
        font-size: 14vh;
        color: #727171;
        text-align: center;
      }
      .confirm-label {
        width: 50%;
        height: 24vh;
        cursor: pointer;
        margin-top: 20vh;
        margin-bottom: 40vh;
        display: inline-block;
        box-sizing: border-box;
        &.right {
          text-align: right;
          padding-right: 17vh;
        }
        &.left {
          text-align: left;
          padding-left: 17vh;
        }
        .hidden-input {
          opacity: 0;
          visibility: hidden;
          position: absolute;
          &:checked + .bui-radios {
            background: #58e078;
            &:after {
              background-size: 100% 100%;
              background-image: url($img+'check.png');
            }
          }
        }
        .bui-radios {
          width: 24vh;
          height: 24vh;
          margin-right: 5vh;
          border-radius: 10px;
          position: relative;
          vertical-align: -3vh;
          background: #9a9a9a;
          display: inline-block;
          transition: all 0.3s linear;
          &:after {
            top: 7vh;
            left: 4vh;
            content: '';
            width: 16vh;
            height: 11vh;
            position: absolute;
            transition: all 0.3s linear;
          }
        }
      }
    }
    .confirm-button {
      height: 46vh;
      color: #fff;
      cursor: pointer;
      font-size: 22vh;
      line-height: 46vh;
      text-align: center;
      border-radius: 23vh;
      background-color: #d670e1;
      &.disabled {
        background-color: #9a9a9a;
        cursor: auto;
        .loading {
          display: inline-block;
          vertical-align: middle;
          width: 30vh;
          height: 30vh;
          background-size: 100% 100%;
          background-image: url($img+'loading.gif');
        }
      }
    }
  }
  .form-btn {
    margin-top: 60vh;
  }
  .form-box {
    div {
      margin-bottom: 10vh;
    }
    &.margin {
      margin-top: 20vh;
    }
  }
  // 针对dmm补充的样式
  #dmm-content {
    width: 500px;
    height: 460px;
    padding: 0;
    background: #e7eef6;
    .close {
      transform: scale(1.5) translateX(6px);
    }
    .popup-title {
      margin: 10px 20px;
    }
    .title-text {
      text-align: left;
      font-size: 16px;
    }
    .content {
      width: 460px;
      height: 400px;
      margin: 0 auto;
      box-sizing: border-box;
      background: white;
      .item {
        list-style: none;
        span {
          display: inline-block;
        }
      }
      .game-name {
        width: 434px;
        line-height: 30px;
        border-bottom: 1px solid #cbcbcb;
        margin: 0 auto;
        span {
          padding-left: 5px;
        }
      }
      .goods-name {
        width: 434px;
        border-bottom: 1px dotted #cbcbcb;
        margin: 0 auto;
        span {
          padding: 12px 0 30px 10px;
        }
      }
      .price,
      .count {
        width: 434px;
        margin: 0 auto;
        padding-top: 13px;
        .tip {
          width: 306px;
          text-align: right;
        }
        .number {
          width: 120px;
          text-align: right;
        }
      }
      .count {
        padding-bottom: 29px;
        border-bottom: 1px solid #cbcbcb;
      }
      .total-price,
      .remain-price {
        width: 434px;
        margin: 0 auto;
        padding-top: 13px;
        .tip {
          width: 306px;
          text-align: right;
        }
        .number {
          width: 120px;
          text-align: right;
        }
      }
      .total-price {
        color: #ff8e00;
      }
      .remain-price {
        padding-bottom: 50px;
      }
      .to-pay {
        margin-top: 58px;
        height: 38px;
        width: 210px;
        margin: 0 auto;
        text-align: center;
        line-height: 38px;
        background: #f9f9f9;
        border-radius: 8px;
        cursor: pointer;
        &:hover {
          color: #ff8e00;
        }
        border: 1px solid #bdbdbd;
        box-sizing: border-box;
      }
      .return-game {
        text-align: center;
        padding-top: 10px;
        color: #3a5a81;
        cursor: pointer;
      }
      // 订单失败tips
      // <li class="item game-name"><span>这是游戏名1111111</span></li>
      // <li class="item fail-tips"><span class="err-msg">这是失败信息293740932</span></li>
      // <li class="item repay"><span class="tip">ポイントをチャージする</span></li>
      // <li class="item return-game"><span>ゲームに戻る</span></li>
      .fail-tips,
      .repay {
        width: 417px;
        height: 45px;
        background: #fffadd;
        margin: 0 auto;
        text-align: center;
      }
      .fail-tips {
        margin-top: 107px;
        padding-top: 16px;
        .err-msg {
          color: #b52113;
        }
      }
      .repay {
        .tip {
          height: 38px;
          width: 210px;
          margin: 0 auto;
          text-align: center;
          line-height: 38px;
          background: #ffb717;
          border-radius: 8px;
          cursor: pointer;
          color: #4a3500;
          &:hover {
            color: #110c01;
          }
          border: 1px solid #bdbdbd;
          box-sizing: border-box;
        }
      }
    }
    .content-error {
      .return-game {
        text-align: center;
        margin-top: 100px;
        color: #3a5a81;
        cursor: pointer;
      }
    }
  }
}
// dmm-移动端
#mobile #dmm-content {
  .content {
    width: 100%;
  }
  .price,
  .count {
    width: 100%;
    .tip {
      width: 66%;
    }
    .number {
      width: 30%;
    }
  }
  .total-price,
  .remain-price {
    width: 100%;
    .tip {
      width: 66%;
    }
    .number {
      width: 30%;
    }
  }
  .fail-tips {
    width: 100%;
  }
}
</style>
